import { useEffect } from "react";
import { Header } from "@/components/aklive/Header";
import { Footer } from "@/components/aklive/Footer";
import { MaskedLines, Reveal } from "@/components/aklive/motion";
import { PlaceholderBlock } from "@/components/aklive/PlaceholderBlock";
import { ContactForm } from "@/components/aklive/contact/ContactForm";

export default function Contact() {
  useEffect(() => {
    document.title = "AKLIVE — Start a Project";
  }, []);

  return (
    <div className="bg-paper text-left text-ink" data-testid="contact-page">
      <Header />
      <main id="main" className="overflow-x-clip">
        <section className="pt-28 md:pt-36" data-testid="contact-hero">
          <div className="container-ak">
            <h1 className="font-display text-5xl font-bold leading-[0.98] tracking-[-0.02em] text-ink sm:text-6xl lg:text-7xl">
              <MaskedLines
                lines={[
                  "What are you",
                  <span key="l2">
                    building next<span className="text-ember">?</span>
                  </span>,
                ]}
              />
            </h1>
            <Reveal delay={0.15} className="mt-6 md:mt-8">
              <p className="max-w-[620px] text-base leading-relaxed text-ink2 md:text-lg">
                Tell us a little about the business, what you're working on and where you'd like our help.
              </p>
            </Reveal>
          </div>
        </section>

        <section className="py-16 pb-24 md:py-24 md:pb-40">
          <div className="container-ak grid gap-16 lg:grid-cols-12 lg:gap-8">
            <div className="lg:col-span-7">
              <ContactForm />
            </div>
            <aside className="lg:col-span-4 lg:col-start-9" data-testid="contact-sidebar">
              <Reveal>
                <div className="border-t border-line pt-8">
                  <h2 className="font-display text-2xl font-bold tracking-tight text-ink md:text-3xl">
                    Prefer email?
                  </h2>
                  <a
                    href="mailto:connect@aklive.studio"
                    data-testid="contact-email-link"
                    className="link-underline mt-4 inline-flex min-h-[44px] items-center font-display text-lg font-bold tracking-tight text-ink hover:text-ember"
                  >
                    connect@aklive.studio
                  </a>
                </div>
              </Reveal>
              <Reveal delay={0.15} className="mt-12 hidden lg:block">
                <PlaceholderBlock label="[PROJECT IMAGE — PORTRAIT]" ratio="4 / 5" />
              </Reveal>
            </aside>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
